// Automatically applies the Availability filter whenever a Size filter is selected.
// Intercepts fetch() calls made by the theme's facet filtering so it works
// regardless of how the theme internally serializes/submits the filter form.

(function () {
  var SIZE_PARAM_HINT = 'option.size';
  var AVAILABILITY_PARAM = 'filter.v.availability';

  function addAvailabilityParam(urlString) {
    try {
      var url = new URL(urlString, window.location.origin);
      var hasSizeFilter = false;

      url.searchParams.forEach(function (value, key) {
        if (key.indexOf(SIZE_PARAM_HINT) !== -1) {
          hasSizeFilter = true;
        }
      });

      if (hasSizeFilter && !url.searchParams.has(AVAILABILITY_PARAM)) {
        url.searchParams.set(AVAILABILITY_PARAM, '1');
        return url.toString();
      }

      if (!hasSizeFilter && url.searchParams.has(AVAILABILITY_PARAM)) {
        url.searchParams.delete(AVAILABILITY_PARAM);
        return url.toString();
      }

      return urlString;
    } catch (e) {
      return urlString;
    }
  }

  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = addAvailabilityParam(input);
      } else if (input instanceof Request) {
        var newUrl = addAvailabilityParam(input.url);
        if (newUrl !== input.url) {
          input = new Request(newUrl, input);
        }
      }
    } catch (e) {
      // fail silently, fall back to original request
    }

    return originalFetch.call(this, input, init);
  };

  // Also handle full page loads / non-AJAX navigations, e.g. clicking a
  // facet link when JS filtering isn't used (progressive enhancement fallback).
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a[href*="option.size"]');
      if (!link) return;

      var newHref = addAvailabilityParam(link.getAttribute('href'));
      if (newHref !== link.getAttribute('href')) {
        link.setAttribute('href', newHref);
      }
    },
    true
  );
})();